import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Alert } from "antd";

type Props = {
  messages: string[];
};

export const ErrorMessages: React.FC<{ messages: string[] }> = ({
  messages
}) => (
  <ul>
    {messages.map(message => (
      <li key={message}>{message}</li>
    ))}
  </ul>
);

export const ErrorBanner: React.FC<Props> = ({ messages }) => {
  return messages.length === 1 ? (
    <Alert type="error" banner message={messages[0]} />
  ) : (
    <Alert
      type="error"
      banner
      message={<ErrorMessages messages={messages} />}
    />
  );
};

export default ErrorBanner;
